/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_Program_AudioInputs */



/**
* | output |
* | --- |
* | "Program Audio" |
*
* @param {Audio_Description_Export_Loudness_Program_AudioInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_program_audio = /** @type {((inputs?: Audio_Description_Export_Loudness_Program_AudioInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_Program_AudioInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Audio du programme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programm-Audio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Audio del programma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Программное аудио")
	if (locale === "es") return /** @type {LocalizedString} */ ("Programa de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("节目音频")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プログラムオーディオ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम ऑडियो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Áudio do programa")
	return /** @type {LocalizedString} */ ("Program Audio")
});